import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_component_svg_icon, {
    width: _ctx.width,
    height: _ctx.height,
    iconColor: _ctx.iconColor,
    viewBoxWidth: "32",
    viewBoxHeight: "32"
  }, {
    default: _withCtx(() => [
      _createElementVNode("path", {
        fill: _ctx.iconColor,
        d: "m20.257 12.34l6.174.903l-4.476 4.39a2 2 0 0 0-.57 1.764l1.053 6.183l-5.502-2.91a2 2 0 0 0-1.87 0l-5.502 2.91l1.054-6.183a2 2 0 0 0-.57-1.764l-4.477-4.39l6.174-.903a2 2 0 0 0 1.507-1.098l2.75-5.607l2.749 5.607a2 2 0 0 0 1.506 1.098m-2.909-8.5c-.549-1.12-2.144-1.12-2.693 0l-3.2 6.52l-7.17 1.05c-1.228.179-1.72 1.686-.834 2.555l5.196 5.096l-1.225 7.183c-.209 1.227 1.08 2.16 2.18 1.578l6.4-3.385l6.398 3.385c1.1.582 2.39-.351 2.18-1.578l-1.224-7.183l5.195-5.096c.886-.87.394-2.376-.833-2.556l-7.171-1.048z"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["width", "height", "iconColor"]))
}